import { getCurrentScope as De, onScopeDispose as xe, toValue as se, shallowRef as de, watch as Ee, computed as ke, defineComponent as je, ref as _e, nextTick as Le, onMounted as Be, onUnmounted as Ge, openBlock as ue, createBlock as Ke, Teleport as Ve, createVNode as ve, Transition as Me, withCtx as $e, createElementBlock as be, mergeProps as qe, createElementVNode as Z, withModifiers as ze, normalizeClass as We, toDisplayString as Ue, unref as Ye, renderSlot as pe, createCommentVNode as he } from "vue";
import { I as He } from "./IconX-DhwnRWP7.js";
import { _ as Xe } from "./IconButton.vue_vue_type_script_setup_true_lang-Bt2ggg8j.js";
function Ze(r, e) {
  return De() ? (xe(r, e), !0) : !1;
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Je = (r) => r != null;
function Qe(r) {
  return Array.isArray(r) ? r : [r];
}
function et(r) {
  var e;
  const t = se(r);
  return (e = t?.$el) !== null && e !== void 0 ? e : t;
}
var Fe = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Q = /* @__PURE__ */ Fe.join(","), Ae = typeof Element > "u", G = Ae ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, ee = !Ae && Element.prototype.getRootNode ? function(r) {
  var e;
  return r == null || (e = r.getRootNode) === null || e === void 0 ? void 0 : e.call(r);
} : function(r) {
  return r?.ownerDocument;
}, te = function(e, t) {
  var n;
  t === void 0 && (t = !0);
  var u = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "inert"), l = u === "" || u === "true", a = l || t && e && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof e.closest == "function" ? e.closest("[inert]") : te(e.parentNode));
  return a;
}, tt = function(e) {
  var t, n = e == null || (t = e.getAttribute) === null || t === void 0 ? void 0 : t.call(e, "contenteditable");
  return n === "" || n === "true";
}, Ie = function(e, t, n) {
  if (te(e))
    return [];
  var u = Array.prototype.slice.apply(e.querySelectorAll(Q));
  return t && G.call(e, Q) && u.unshift(e), u = u.filter(n), u;
}, re = function(e, t, n) {
  for (var u = [], l = Array.from(e); l.length; ) {
    var a = l.shift();
    if (!te(a, !1))
      if (a.tagName === "SLOT") {
        var c = a.assignedElements(), f = c.length ? c : a.children, p = re(f, !0, n);
        n.flatten ? u.push.apply(u, p) : u.push({
          scopeParent: a,
          candidates: p
        });
      } else {
        var S = G.call(a, Q);
        S && n.filter(a) && (t || !e.includes(a)) && u.push(a);
        var v = a.shadowRoot || // check for an undisclosed shadow
        typeof n.getShadowRoot == "function" && n.getShadowRoot(a), N = !te(v, !1) && (!n.shadowRootFilter || n.shadowRootFilter(a));
        if (v && N) {
          var I = re(v === !0 ? a.children : v.children, !0, n);
          n.flatten ? u.push.apply(u, I) : u.push({
            scopeParent: a,
            candidates: I
          });
        } else
          l.unshift.apply(l, a.children);
      }
  }
  return u;
}, Re = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, B = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || tt(e)) && !Re(e) ? 0 : e.tabIndex;
}, rt = function(e, t) {
  var n = B(e);
  return n < 0 && t && !Re(e) ? 0 : n;
}, at = function(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, Oe = function(e) {
  return e.tagName === "INPUT";
}, nt = function(e) {
  return Oe(e) && e.type === "hidden";
}, it = function(e) {
  var t = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return t;
}, ot = function(e, t) {
  for (var n = 0; n < e.length; n++)
    if (e[n].checked && e[n].form === t)
      return e[n];
}, ut = function(e) {
  if (!e.name)
    return !0;
  var t = e.form || ee(e), n = function(c) {
    return t.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, u;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    u = n(window.CSS.escape(e.name));
  else
    try {
      u = n(e.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var l = ot(u, e.form);
  return !l || l === e;
}, lt = function(e) {
  return Oe(e) && e.type === "radio";
}, st = function(e) {
  return lt(e) && !ut(e);
}, ct = function(e) {
  var t, n = e && ee(e), u = (t = n) === null || t === void 0 ? void 0 : t.host, l = !1;
  if (n && n !== e) {
    var a, c, f;
    for (l = !!((a = u) !== null && a !== void 0 && (c = a.ownerDocument) !== null && c !== void 0 && c.contains(u) || e != null && (f = e.ownerDocument) !== null && f !== void 0 && f.contains(e)); !l && u; ) {
      var p, S, v;
      n = ee(u), u = (p = n) === null || p === void 0 ? void 0 : p.host, l = !!((S = u) !== null && S !== void 0 && (v = S.ownerDocument) !== null && v !== void 0 && v.contains(u));
    }
  }
  return l;
}, ye = function(e) {
  var t = e.getBoundingClientRect(), n = t.width, u = t.height;
  return n === 0 && u === 0;
}, ft = function(e, t) {
  var n = t.displayCheck, u = t.getShadowRoot;
  if (n === "full-native" && "checkVisibility" in e) {
    var l = e.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !l;
  }
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var a = G.call(e, "details>summary:first-of-type"), c = a ? e.parentElement : e;
  if (G.call(c, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  n === "full-native" || n === "legacy-full") {
    if (typeof u == "function") {
      for (var f = e; e; ) {
        var p = e.parentElement, S = ee(e);
        if (p && !p.shadowRoot && u(p) === !0)
          return ye(e);
        e.assignedSlot ? e = e.assignedSlot : !p && S !== e.ownerDocument ? e = S.host : e = p;
      }
      e = f;
    }
    if (ct(e))
      return !e.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return ye(e);
  return !1;
}, dt = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var t = e.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var n = 0; n < t.children.length; n++) {
          var u = t.children.item(n);
          if (u.tagName === "LEGEND")
            return G.call(t, "fieldset[disabled] *") ? !0 : !u.contains(e);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, ae = function(e, t) {
  return !(t.disabled || nt(t) || ft(t, e) || // For a details element with a summary, the summary element gets the focus
  it(t) || dt(t));
}, ce = function(e, t) {
  return !(st(t) || B(t) < 0 || !ae(e, t));
}, vt = function(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, Pe = function(e) {
  var t = [], n = [];
  return e.forEach(function(u, l) {
    var a = !!u.scopeParent, c = a ? u.scopeParent : u, f = rt(c, a), p = a ? Pe(u.candidates) : c;
    f === 0 ? a ? t.push.apply(t, p) : t.push(c) : n.push({
      documentOrder: l,
      tabIndex: f,
      item: u,
      isScope: a,
      content: p
    });
  }), n.sort(at).reduce(function(u, l) {
    return l.isScope ? u.push.apply(u, l.content) : u.push(l.content), u;
  }, []).concat(t);
}, bt = function(e, t) {
  t = t || {};
  var n;
  return t.getShadowRoot ? n = re([e], t.includeContainer, {
    filter: ce.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: vt
  }) : n = Ie(e, t.includeContainer, ce.bind(null, t)), Pe(n);
}, pt = function(e, t) {
  t = t || {};
  var n;
  return t.getShadowRoot ? n = re([e], t.includeContainer, {
    filter: ae.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : n = Ie(e, t.includeContainer, ae.bind(null, t)), n;
}, V = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return G.call(e, Q) === !1 ? !1 : ce(t, e);
}, ht = /* @__PURE__ */ Fe.concat("iframe:not([inert]):not([inert] *)").join(","), le = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return G.call(e, ht) === !1 ? !1 : ae(t, e);
};
function fe(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function yt(r) {
  if (Array.isArray(r)) return fe(r);
}
function me(r, e, t, n, u, l, a) {
  try {
    var c = r[l](a), f = c.value;
  } catch (p) {
    return void t(p);
  }
  c.done ? e(f) : Promise.resolve(f).then(n, u);
}
function ge(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(n, u) {
      var l = r.apply(e, t);
      function a(f) {
        me(l, n, u, a, c, "next", f);
      }
      function c(f) {
        me(l, n, u, a, c, "throw", f);
      }
      a(void 0);
    });
  };
}
function we(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = Ce(r)) || e) {
      t && (r = t);
      var n = 0, u = function() {
      };
      return {
        s: u,
        n: function() {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function(f) {
          throw f;
        },
        f: u
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var l, a = !0, c = !1;
  return {
    s: function() {
      t = t.call(r);
    },
    n: function() {
      var f = t.next();
      return a = f.done, f;
    },
    e: function(f) {
      c = !0, l = f;
    },
    f: function() {
      try {
        a || t.return == null || t.return();
      } finally {
        if (c) throw l;
      }
    }
  };
}
function mt(r, e, t) {
  return (e = Nt(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function gt(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
}
function wt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Se(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(u) {
      return Object.getOwnPropertyDescriptor(r, u).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Te(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Se(Object(t), !0).forEach(function(n) {
      mt(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Se(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function q() {
  var r, e, t = typeof Symbol == "function" ? Symbol : {}, n = t.iterator || "@@iterator", u = t.toStringTag || "@@toStringTag";
  function l(I, P, W, U) {
    var K = P && P.prototype instanceof c ? P : c, M = Object.create(K.prototype);
    return O(M, "_invoke", (function(ne, Y, H) {
      var C, T, F, _ = 0, X = H || [], D = !1, k = {
        p: 0,
        n: 0,
        v: r,
        a: m,
        f: m.bind(r, 4),
        d: function(i, o) {
          return C = i, T = 0, F = r, k.n = o, a;
        }
      };
      function m(i, o) {
        for (T = i, F = o, e = 0; !D && _ && !s && e < X.length; e++) {
          var s, d = X[e], h = k.p, y = d[2];
          i > 3 ? (s = y === o) && (F = d[(T = d[4]) ? 5 : (T = 3, 3)], d[4] = d[5] = r) : d[0] <= h && ((s = i < 2 && h < d[1]) ? (T = 0, k.v = o, k.n = d[1]) : h < y && (s = i < 3 || d[0] > o || o > y) && (d[4] = i, d[5] = o, k.n = y, T = 0));
        }
        if (s || i > 1) return a;
        throw D = !0, o;
      }
      return function(i, o, s) {
        if (_ > 1) throw TypeError("Generator is already running");
        for (D && o === 1 && m(o, s), T = o, F = s; (e = T < 2 ? r : F) || !D; ) {
          C || (T ? T < 3 ? (T > 1 && (k.n = -1), m(T, F)) : k.n = F : k.v = F);
          try {
            if (_ = 2, C) {
              if (T || (i = "next"), e = C[i]) {
                if (!(e = e.call(C, F))) throw TypeError("iterator result is not an object");
                if (!e.done) return e;
                F = e.value, T < 2 && (T = 0);
              } else T === 1 && (e = C.return) && e.call(C), T < 2 && (F = TypeError("The iterator does not provide a '" + i + "' method"), T = 1);
              C = r;
            } else if ((e = (D = k.n < 0) ? F : ne.call(Y, k)) !== a) break;
          } catch (d) {
            C = r, T = 1, F = d;
          } finally {
            _ = 1;
          }
        }
        return {
          value: e,
          done: D
        };
      };
    })(I, W, U), !0), M;
  }
  var a = {};
  function c() {
  }
  function f() {
  }
  function p() {
  }
  e = Object.getPrototypeOf;
  var S = [][n] ? e(e([][n]())) : (O(e = {}, n, function() {
    return this;
  }), e), v = p.prototype = c.prototype = Object.create(S);
  function N(I) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(I, p) : (I.__proto__ = p, O(I, u, "GeneratorFunction")), I.prototype = Object.create(v), I;
  }
  return f.prototype = p, O(v, "constructor", p), O(p, "constructor", f), f.displayName = "GeneratorFunction", O(p, u, "GeneratorFunction"), O(v), O(v, u, "Generator"), O(v, n, function() {
    return this;
  }), O(v, "toString", function() {
    return "[object Generator]";
  }), (q = function() {
    return {
      w: l,
      m: N
    };
  })();
}
function O(r, e, t, n) {
  var u = Object.defineProperty;
  try {
    u({}, "", {});
  } catch {
    u = 0;
  }
  O = function(l, a, c, f) {
    function p(S, v) {
      O(l, S, function(N) {
        return this._invoke(S, v, N);
      });
    }
    a ? u ? u(l, a, {
      value: c,
      enumerable: !f,
      configurable: !f,
      writable: !f
    }) : l[a] = c : (p("next", 0), p("throw", 1), p("return", 2));
  }, O(r, e, t, n);
}
function St(r) {
  return yt(r) || gt(r) || Ce(r) || wt();
}
function Tt(r, e) {
  if (typeof r != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function Nt(r) {
  var e = Tt(r, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Ce(r, e) {
  if (r) {
    if (typeof r == "string") return fe(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? fe(r, e) : void 0;
  }
}
var x = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(e) {
    return e?.length > 0 ? e[e.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(e, t) {
    var n = x.getActiveTrap(e);
    t !== n && x.pauseTrap(e);
    var u = e.indexOf(t);
    u === -1 || e.splice(u, 1), e.push(t);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(e, t) {
    var n = e.indexOf(t);
    n !== -1 && e.splice(n, 1), x.unpauseTrap(e);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(e) {
    var t = x.getActiveTrap(e);
    t?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(e) {
    var t = x.getActiveTrap(e);
    t && !t._isManuallyPaused() && t._setPausedState(!1);
  }
}, Et = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, kt = function(e) {
  return e?.key === "Escape" || e?.key === "Esc" || e?.keyCode === 27;
}, z = function(e) {
  return e?.key === "Tab" || e?.keyCode === 9;
}, Ft = function(e) {
  return z(e) && !e.shiftKey;
}, At = function(e) {
  return z(e) && e.shiftKey;
}, Ne = function(e) {
  return setTimeout(e, 0);
}, $ = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), u = 1; u < t; u++)
    n[u - 1] = arguments[u];
  return typeof e == "function" ? e.apply(void 0, n) : e;
}, J = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, It = [], Rt = function(e, t) {
  var n = t?.document || document, u = t?.trapStack || It, l = Te({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Ft,
    isKeyBackward: At
  }, t), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, c, f = function(i, o, s) {
    return i && i[o] !== void 0 ? i[o] : l[s || o];
  }, p = function(i, o) {
    var s = typeof o?.composedPath == "function" ? o.composedPath() : void 0;
    return a.containerGroups.findIndex(function(d) {
      var h = d.container, y = d.tabbableNodes;
      return h.contains(i) || s?.includes(h) || y.find(function(b) {
        return b === i;
      });
    });
  }, S = function(i) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = o.hasFallback, d = s === void 0 ? !1 : s, h = o.params, y = h === void 0 ? [] : h, b = l[i];
    if (typeof b == "function" && (b = b.apply(void 0, St(y))), b === !0 && (b = void 0), !b) {
      if (b === void 0 || b === !1)
        return b;
      throw new Error("`".concat(i, "` was specified but was not a node, or did not return a node"));
    }
    var g = b;
    if (typeof b == "string") {
      try {
        g = n.querySelector(b);
      } catch (w) {
        throw new Error("`".concat(i, '` appears to be an invalid selector; error="').concat(w.message, '"'));
      }
      if (!g && !d)
        throw new Error("`".concat(i, "` as selector refers to no known node"));
    }
    return g;
  }, v = function() {
    var i = S("initialFocus", {
      hasFallback: !0
    });
    if (i === !1)
      return !1;
    if (i === void 0 || i && !le(i, l.tabbableOptions))
      if (p(n.activeElement) >= 0)
        i = n.activeElement;
      else {
        var o = a.tabbableGroups[0], s = o && o.firstTabbableNode;
        i = s || S("fallbackFocus");
      }
    else i === null && (i = S("fallbackFocus"));
    if (!i)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return i;
  }, N = function() {
    if (a.containerGroups = a.containers.map(function(i) {
      var o = bt(i, l.tabbableOptions), s = pt(i, l.tabbableOptions), d = o.length > 0 ? o[0] : void 0, h = o.length > 0 ? o[o.length - 1] : void 0, y = s.find(function(w) {
        return V(w);
      }), b = s.slice().reverse().find(function(w) {
        return V(w);
      }), g = !!o.find(function(w) {
        return B(w) > 0;
      });
      return {
        container: i,
        tabbableNodes: o,
        focusableNodes: s,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: g,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: d,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: h,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: y,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: b,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(E) {
          var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, A = o.indexOf(E);
          return A < 0 ? R ? s.slice(s.indexOf(E) + 1).find(function(L) {
            return V(L);
          }) : s.slice(0, s.indexOf(E)).reverse().find(function(L) {
            return V(L);
          }) : o[A + (R ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(i) {
      return i.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !S("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(i) {
      return i.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, I = function(i) {
    var o = i.activeElement;
    if (o)
      return o.shadowRoot && o.shadowRoot.activeElement !== null ? I(o.shadowRoot) : o;
  }, P = function(i) {
    if (i !== !1 && i !== I(document)) {
      if (!i || !i.focus) {
        P(v());
        return;
      }
      i.focus({
        preventScroll: !!l.preventScroll
      }), a.mostRecentlyFocusedNode = i, Et(i) && i.select();
    }
  }, W = function(i) {
    var o = S("setReturnFocus", {
      params: [i]
    });
    return o || (o === !1 ? !1 : i);
  }, U = function(i) {
    var o = i.target, s = i.event, d = i.isBackward, h = d === void 0 ? !1 : d;
    o = o || J(s), N();
    var y = null;
    if (a.tabbableGroups.length > 0) {
      var b = p(o, s), g = b >= 0 ? a.containerGroups[b] : void 0;
      if (b < 0)
        h ? y = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : y = a.tabbableGroups[0].firstTabbableNode;
      else if (h) {
        var w = a.tabbableGroups.findIndex(function(ie) {
          var oe = ie.firstTabbableNode;
          return o === oe;
        });
        if (w < 0 && (g.container === o || le(o, l.tabbableOptions) && !V(o, l.tabbableOptions) && !g.nextTabbableNode(o, !1)) && (w = b), w >= 0) {
          var E = w === 0 ? a.tabbableGroups.length - 1 : w - 1, R = a.tabbableGroups[E];
          y = B(o) >= 0 ? R.lastTabbableNode : R.lastDomTabbableNode;
        } else z(s) || (y = g.nextTabbableNode(o, !1));
      } else {
        var A = a.tabbableGroups.findIndex(function(ie) {
          var oe = ie.lastTabbableNode;
          return o === oe;
        });
        if (A < 0 && (g.container === o || le(o, l.tabbableOptions) && !V(o, l.tabbableOptions) && !g.nextTabbableNode(o)) && (A = b), A >= 0) {
          var L = A === a.tabbableGroups.length - 1 ? 0 : A + 1, j = a.tabbableGroups[L];
          y = B(o) >= 0 ? j.firstTabbableNode : j.firstDomTabbableNode;
        } else z(s) || (y = g.nextTabbableNode(o));
      }
    } else
      y = S("fallbackFocus");
    return y;
  }, K = function(i) {
    var o = J(i);
    if (!(p(o, i) >= 0)) {
      if ($(l.clickOutsideDeactivates, i)) {
        c.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: l.returnFocusOnDeactivate
        });
        return;
      }
      $(l.allowOutsideClick, i) || i.preventDefault();
    }
  }, M = function(i) {
    var o = J(i), s = p(o, i) >= 0;
    if (s || o instanceof Document)
      s && (a.mostRecentlyFocusedNode = o);
    else {
      i.stopImmediatePropagation();
      var d, h = !0;
      if (a.mostRecentlyFocusedNode)
        if (B(a.mostRecentlyFocusedNode) > 0) {
          var y = p(a.mostRecentlyFocusedNode), b = a.containerGroups[y].tabbableNodes;
          if (b.length > 0) {
            var g = b.findIndex(function(w) {
              return w === a.mostRecentlyFocusedNode;
            });
            g >= 0 && (l.isKeyForward(a.recentNavEvent) ? g + 1 < b.length && (d = b[g + 1], h = !1) : g - 1 >= 0 && (d = b[g - 1], h = !1));
          }
        } else
          a.containerGroups.some(function(w) {
            return w.tabbableNodes.some(function(E) {
              return B(E) > 0;
            });
          }) || (h = !1);
      else
        h = !1;
      h && (d = U({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: l.isKeyBackward(a.recentNavEvent)
      })), P(d || a.mostRecentlyFocusedNode || v());
    }
    a.recentNavEvent = void 0;
  }, ne = function(i) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = i;
    var s = U({
      event: i,
      isBackward: o
    });
    s && (z(i) && i.preventDefault(), P(s));
  }, Y = function(i) {
    (l.isKeyForward(i) || l.isKeyBackward(i)) && ne(i, l.isKeyBackward(i));
  }, H = function(i) {
    kt(i) && $(l.escapeDeactivates, i) !== !1 && (i.preventDefault(), c.deactivate());
  }, C = function(i) {
    var o = J(i);
    p(o, i) >= 0 || $(l.clickOutsideDeactivates, i) || $(l.allowOutsideClick, i) || (i.preventDefault(), i.stopImmediatePropagation());
  }, T = function() {
    if (!a.active)
      return Promise.resolve();
    x.activateTrap(u, c);
    var i;
    return l.delayInitialFocus ? i = new Promise(function(o) {
      a.delayInitialFocusTimer = Ne(function() {
        P(v()), o();
      });
    }) : (i = Promise.resolve(), P(v())), n.addEventListener("focusin", M, !0), n.addEventListener("mousedown", K, {
      capture: !0,
      passive: !1
    }), n.addEventListener("touchstart", K, {
      capture: !0,
      passive: !1
    }), n.addEventListener("click", C, {
      capture: !0,
      passive: !1
    }), n.addEventListener("keydown", Y, {
      capture: !0,
      passive: !1
    }), n.addEventListener("keydown", H), i;
  }, F = function(i) {
    a.active && !a.paused && c._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), d = we(i), h;
    try {
      for (d.s(); !(h = d.n()).done; ) {
        var y = h.value;
        o.add(y);
        for (var b = typeof ShadowRoot < "u" && y.getRootNode() instanceof ShadowRoot, g = y; g; ) {
          o.add(g);
          var w = g.parentElement, E = [];
          w ? E = w.children : !w && b && (E = g.getRootNode().children, w = g.getRootNode().host, b = typeof ShadowRoot < "u" && w.getRootNode() instanceof ShadowRoot);
          var R = we(E), A;
          try {
            for (R.s(); !(A = R.n()).done; ) {
              var L = A.value;
              s.add(L);
            }
          } catch (j) {
            R.e(j);
          } finally {
            R.f();
          }
          g = w;
        }
      }
    } catch (j) {
      d.e(j);
    } finally {
      d.f();
    }
    o.forEach(function(j) {
      s.delete(j);
    }), a.adjacentElements = s;
  }, _ = function() {
    if (a.active)
      return n.removeEventListener("focusin", M, !0), n.removeEventListener("mousedown", K, !0), n.removeEventListener("touchstart", K, !0), n.removeEventListener("click", C, !0), n.removeEventListener("keydown", Y, !0), n.removeEventListener("keydown", H), c;
  }, X = function(i) {
    var o = i.some(function(s) {
      var d = Array.from(s.removedNodes);
      return d.some(function(h) {
        return h === a.mostRecentlyFocusedNode;
      });
    });
    o && P(v());
  }, D = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(X) : void 0, k = function() {
    D && (D.disconnect(), a.active && !a.paused && a.containers.map(function(i) {
      D.observe(i, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return c = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(i) {
      if (a.active)
        return this;
      var o = f(i, "onActivate"), s = f(i, "onPostActivate"), d = f(i, "checkCanFocusTrap"), h = x.getActiveTrap(u), y = !1;
      if (h && !h.paused) {
        var b;
        (b = h._setSubtreeIsolation) === null || b === void 0 || b.call(h, !1), y = !0;
      }
      try {
        d || N(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = I(n), o?.();
        var g = /* @__PURE__ */ (function() {
          var E = ge(/* @__PURE__ */ q().m(function R() {
            return q().w(function(A) {
              for (; ; ) switch (A.n) {
                case 0:
                  return d && N(), A.n = 1, T();
                case 1:
                  c._setSubtreeIsolation(!0), k(), s?.();
                case 2:
                  return A.a(2);
              }
            }, R);
          }));
          return function() {
            return E.apply(this, arguments);
          };
        })();
        if (d)
          return d(a.containers.concat()).then(g, g), this;
        g();
      } catch (E) {
        if (h === x.getActiveTrap(u) && y) {
          var w;
          (w = h._setSubtreeIsolation) === null || w === void 0 || w.call(h, !0);
        }
        throw E;
      }
      return this;
    },
    deactivate: function(i) {
      if (!a.active)
        return this;
      var o = Te({
        onDeactivate: l.onDeactivate,
        onPostDeactivate: l.onPostDeactivate,
        checkCanReturnFocus: l.checkCanReturnFocus
      }, i);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || c._setSubtreeIsolation(!1), a.alreadySilent.clear(), _(), a.active = !1, a.paused = !1, k(), x.deactivateTrap(u, c);
      var s = f(o, "onDeactivate"), d = f(o, "onPostDeactivate"), h = f(o, "checkCanReturnFocus"), y = f(o, "returnFocus", "returnFocusOnDeactivate");
      s?.();
      var b = function() {
        Ne(function() {
          y && P(W(a.nodeFocusedBeforeActivation)), d?.();
        });
      };
      return y && h ? (h(W(a.nodeFocusedBeforeActivation)).then(b, b), this) : (b(), this);
    },
    pause: function(i) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, i)) : this;
    },
    unpause: function(i) {
      return a.active ? (a.manuallyPaused = !1, u[u.length - 1] !== this ? this : this._setPausedState(!1, i)) : this;
    },
    updateContainerElements: function(i) {
      var o = [].concat(i).filter(Boolean);
      return a.containers = o.map(function(s) {
        return typeof s == "string" ? n.querySelector(s) : s;
      }), l.isolateSubtrees && F(a.containers), a.active && (N(), a.paused || c._setSubtreeIsolation(!0)), k(), this;
    }
  }, Object.defineProperties(c, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(i, o) {
        if (a.paused === i)
          return this;
        if (a.paused = i, i) {
          var s = f(o, "onPause"), d = f(o, "onPostPause");
          s?.(), _(), c._setSubtreeIsolation(!1), k(), d?.();
        } else {
          var h = f(o, "onUnpause"), y = f(o, "onPostUnpause");
          h?.();
          var b = /* @__PURE__ */ (function() {
            var g = ge(/* @__PURE__ */ q().m(function w() {
              return q().w(function(E) {
                for (; ; ) switch (E.n) {
                  case 0:
                    return N(), E.n = 1, T();
                  case 1:
                    c._setSubtreeIsolation(!0), k(), y?.();
                  case 2:
                    return E.a(2);
                }
              }, w);
            }));
            return function() {
              return g.apply(this, arguments);
            };
          })();
          b();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(i) {
        l.isolateSubtrees && a.adjacentElements.forEach(function(o) {
          var s;
          i ? l.isolateSubtrees === "aria-hidden" ? ((o.ariaHidden === "true" || ((s = o.getAttribute("aria-hidden")) === null || s === void 0 ? void 0 : s.toLowerCase()) === "true") && a.alreadySilent.add(o), o.setAttribute("aria-hidden", "true")) : ((o.inert || o.hasAttribute("inert")) && a.alreadySilent.add(o), o.setAttribute("inert", !0)) : a.alreadySilent.has(o) || (l.isolateSubtrees === "aria-hidden" ? o.removeAttribute("aria-hidden") : o.removeAttribute("inert"));
        });
      }
    }
  }), c.updateContainerElements(e), c;
};
function Ot(r, e = {}) {
  let t;
  const { immediate: n, ...u } = e, l = de(!1), a = de(!1), c = (v) => t && t.activate(v), f = (v) => t && t.deactivate(v), p = () => {
    t && (t.pause(), a.value = !0);
  }, S = () => {
    t && (t.unpause(), a.value = !1);
  };
  return Ee(ke(() => Qe(se(r)).map((v) => {
    const N = se(v);
    return typeof N == "string" ? N : et(N);
  }).filter(Je)), (v) => {
    if (v.length)
      if (!t)
        t = Rt(v, {
          ...u,
          onActivate() {
            l.value = !0, e.onActivate && e.onActivate();
          },
          onDeactivate() {
            l.value = !1, e.onDeactivate && e.onDeactivate();
          }
        }), n && c();
      else {
        const N = t?.active;
        t?.updateContainerElements(v), !N && n && c();
      }
  }, { flush: "post" }), Ze(() => f()), {
    hasFocus: l,
    isPaused: a,
    activate: c,
    deactivate: f,
    pause: p,
    unpause: S
  };
}
const Pt = { class: "flex items-center justify-between px-6 py-4 border-b border-border-subtle shrink-0" }, Ct = { class: "text-lg font-semibold text-text-main" }, Dt = { class: "p-6 overflow-y-auto hb-scrollbar" }, xt = {
  key: 0,
  class: "px-6 py-4 border-t border-border-subtle flex justify-end gap-3 shrink-0"
}, Bt = /* @__PURE__ */ je({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md",
      validator: (r) => ["sm", "md", "lg", "xl"].includes(r)
    },
    dismissible: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue", "close"],
  setup(r, { emit: e }) {
    const t = r, n = e, u = _e(null), { activate: l, deactivate: a } = Ot(u, {
      immediate: !1,
      allowOutsideClick: !0,
      initialFocus: () => u.value?.querySelector("[autofocus]") || u.value
    }), c = ke(() => {
      switch (t.size) {
        case "sm":
          return "max-w-md";
        case "lg":
          return "max-w-2xl";
        case "xl":
          return "max-w-4xl";
        default:
          return "max-w-lg";
      }
    }), f = () => {
      n("update:modelValue", !1), n("close");
    }, p = () => {
      t.dismissible && f();
    }, S = (v) => {
      v.key === "Escape" && t.modelValue && t.dismissible && f();
    };
    return Ee(
      () => t.modelValue,
      async (v) => {
        v ? (document.body.style.overflow = "hidden", await Le(), u.value && l()) : (document.body.style.overflow = "", a());
      }
    ), Be(() => {
      document.addEventListener("keydown", S);
    }), Ge(() => {
      document.removeEventListener("keydown", S), document.body.style.overflow = "", a();
    }), (v, N) => (ue(), Ke(Ve, { to: "body" }, [
      ve(Me, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: $e(() => [
          r.modelValue ? (ue(), be("div", qe({
            key: 0,
            class: "fixed inset-0 z-9999 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm",
            onClick: p
          }, v.$attrs), [
            Z("div", {
              ref_key: "modalRef",
              ref: u,
              class: We(["relative bg-bg-card rounded-card shadow-lift w-full max-h-[90vh] flex flex-col overflow-hidden", c.value]),
              onClick: N[0] || (N[0] = ze(() => {
              }, ["stop"]))
            }, [
              Z("div", Pt, [
                Z("h3", Ct, Ue(r.title), 1),
                ve(Xe, {
                  variant: "ghost",
                  size: "sm",
                  onClick: f,
                  icon: Ye(He)
                }, null, 8, ["icon"])
              ]),
              Z("div", Dt, [
                pe(v.$slots, "default")
              ]),
              v.$slots.footer ? (ue(), be("div", xt, [
                pe(v.$slots, "footer")
              ])) : he("", !0)
            ], 2)
          ], 16)) : he("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
export {
  Bt as _
};
